import React from 'react';
import { Size } from '../../../../Enums/Size.enum';
import Modal from '../../../BaseModule/Components/Modal';
import DrMaxReserveMedicaments from './DrMaxReserveMedicaments';
import { Pharmacy } from '../DrMaxPharmacyList/DrMaxPharmacyListItem';

interface Props {
	isOpen: boolean;
	onClose: () => void;
	prescriptionId: string;
	pharmacy: Pharmacy;
}

const DrMaxReserveMedicamentsModal: React.FC<Props> = ({
	isOpen,
	onClose,
	prescriptionId,
	pharmacy,
}) => {
	return (
		<Modal opened={isOpen} onClose={onClose} size={Size.SM}>
			<Modal.Header title={'component.drmax.reserveAtPharmacy2'} />
			<Modal.Content>
				<DrMaxReserveMedicaments
					prescriptionId={prescriptionId}
					pharmacy={pharmacy}
					onSuccess={onClose}
					onPharmacyChange={onClose}
				/>
			</Modal.Content>
		</Modal>
	);
};

export default DrMaxReserveMedicamentsModal;
